/**
 * Product Card Swiper init — Ivonne
 * --------------------------------------------------------------
 * Inicializa Swiper sobre cada `.product-card__swiper` y lo
 * re-inicializa cuando el AJAX de Prestige (paginacion, facets,
 * sort) reemplaza el contenido de <product-list>.
 *
 * Notas:
 * - Idempotente: si un .product-card__swiper ya fue inicializado,
 *   no se vuelve a instanciar (evita memory leaks).
 * - El observer escucha addedNodes en todo <body> pero solo actua
 *   sobre nodos `.product-card__swiper`.
 * - Comportamiento por dispositivo:
 *     desktop = hover + swipe (dots ocultos por CSS)
 *     mobile  = solo swipe + dots (<= 950px)
 *   Los dots se inyectan por JS (el snippet no trae .swiper-pagination)
 *   y se muestran/ocultan via media query.
 */
(function () {
  'use strict';

  var INIT_FLAG = 'swiperInitialized';

  // --- Config hover -------------------------------------------------------
  var HOVER_SLIDE_INDEX = 1;   // slide a mostrar en hover (1 = segunda imagen)
  var REST_SLIDE_INDEX  = 0;   // slide al que se regresa al salir
  var HOVER_SPEED       = 0;   // ms de transicion (0 = instantaneo, sin carrusel)

  var CAN_HOVER = window.matchMedia
    ? window.matchMedia('(hover: hover) and (pointer: fine)').matches
    : true;

  // --- Estado global de arrastre (compartido entre todas las tarjetas) ----
  var pointerDown = false;   // hay un puntero presionado en este momento
  var lockedEntry = null;    // { target, swiper } de la tarjeta "tomada"
  var hoveredTarget = null;  // tarjeta sobre la que esta fisicamente el cursor

  function releasePointer() {
    pointerDown = false;
    if (lockedEntry) {
      if (hoveredTarget !== lockedEntry.target) {
        lockedEntry.swiper.slideTo(REST_SLIDE_INDEX, HOVER_SPEED);
      }
      lockedEntry = null;
    }
  }

  document.addEventListener('pointerdown', function () { pointerDown = true; });
  document.addEventListener('pointerup', releasePointer);
  document.addEventListener('pointercancel', releasePointer);

  // --- Dots ---------------------------------------------------------------
  // El snippet no incluye .swiper-pagination, asi que lo creamos como hijo
  // directo del contenedor (NO dentro de .swiper-wrapper, o seria un slide).
  function ensurePagination(el) {
    var existing = el.querySelector('.swiper-pagination');
    if (existing) return existing;
    var pag = document.createElement('div');
    pag.className = 'swiper-pagination';
    el.appendChild(pag);
    return pag;
  }

  function wireHover(el, swiper) {
    if (!CAN_HOVER) return;                        // touch: solo swipe
    if (!swiper || swiper.slides.length < 2) return;

    var hoverTarget = el.closest('.product-card') || el;

    hoverTarget.addEventListener('pointerdown', function () {
      lockedEntry = { target: hoverTarget, swiper: swiper };
    });

    hoverTarget.addEventListener('mouseenter', function () {
      hoveredTarget = hoverTarget;
      if (pointerDown) return;
      swiper.slideTo(HOVER_SLIDE_INDEX, HOVER_SPEED);
    });

    hoverTarget.addEventListener('mouseleave', function () {
      if (hoveredTarget === hoverTarget) hoveredTarget = null;
      if (pointerDown && lockedEntry && lockedEntry.target === hoverTarget) return;
      swiper.slideTo(REST_SLIDE_INDEX, HOVER_SPEED);
    });
  }

  function initSingleSwiper(el) {
    if (!el || el.nodeType !== 1) return;
    if (el.dataset[INIT_FLAG] === 'true') return;
    if (typeof Swiper === 'undefined') return;

    var swiper = new Swiper(el, {
      loop: false,
      spaceBetween: 10,
      slidesPerView: 1,
      pagination: {
        el: ensurePagination(el),
        clickable: true,
        dynamicBullets: true   // opcional: agrupa los dots si hay muchas imagenes
      }
    });

    wireHover(el, swiper);

    el.dataset[INIT_FLAG] = 'true';
  }

  function initSwipersIn(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;
    var nodes = scope.querySelectorAll('.product-card__swiper');
    for (var i = 0; i < nodes.length; i++) initSingleSwiper(nodes[i]);
  }

  // --- Pasada inicial -----------------------------------------------------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSwipersIn(document);
    });
  } else {
    initSwipersIn(document);
  }

  // --- Re-init en cambios de DOM (paginacion/facets AJAX) -----------------
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('.product-card__swiper')) {
          initSingleSwiper(node);
        }
        initSwipersIn(node);
      }
    }
  });

  function startObserving() {
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) {
    startObserving();
  } else {
    document.addEventListener('DOMContentLoaded', startObserving);
  }
})();